import "~/misc/common";
import { p } from "~/misc/common";
import L from "~/misc/2d/leaflet";
import { refreshControlPanelMaxHeight } from "~/misc/2d/misc";
import { savePZ } from '~/misc/2d/save_pz';
import "~/misc/jstree";
import { initMapLayers } from "./map_layers";
import { Context2d, MapData } from "~/types/map";

export function initMapLayered() {
  p('initMapLayered');

  const map = L.map('mapol', {
    maxZoom: 19,
    editable: true,
    zoomControl: false
  }) as Context2d;

  savePZ(map);
  refreshControlPanelMaxHeight();

  map.noState = (localStorage.getItem('treeMap') == null);

  $('#treeLayers').jstree({
    "plugins": ["contextmenu", "state", "checkbox", "changed"],
    'core': {
      "check_callback": true
    },
    'contextmenu': {
      'items': {}
    },
    "state": {
      "key": "treeMap"
    },
    "checkbox": {
      "whole_node": true,
      "tie_selection": false
    }
  });
  map.tree = $('#treeLayers').jstree(true);

  $('#treeLayers').hide(400);
  $('#panelLayers').on('click', function () {
    $('#treeLayers').show();
    $('#treeToggle').hide();
  });
  map.on("click movestart zoomstart", function (e) {
    $('#treeLayers').hide();
    $('#treeToggle').show();
  });

  initMapLayers(map);

  map.data = $('#toJs').data() as MapData;
  p(map.data);
  map.launchAreas = {};

  return map;
}